var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ZoneForm',{attrs:{"title":"Add zone","main-error":_vm.mainError,"inputs-errors":_vm.inputsErrors},on:{"submit":_vm.submit}})}
var staticRenderFns = []

export { render, staticRenderFns }